import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=2a357126&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=2a357126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a357126",
  null
  
)

export default component.exports